import { Pipe, PipeTransform } from '@angular/core';
import * as $ from "jquery";
@Pipe({
  name: 'curency'
})
export class CurencyPipe implements PipeTransform {


  constructor() {
  }

  transform(value) {


    let currency = localStorage.currency;
    let decimals = localStorage.decimals;
    let currecnyPos = localStorage.currencyPos;

    var priceFixed = parseFloat(value).toFixed(decimals);

    var formatNumber = {
      separador: ".", // separador para los miles
      sepDecimal: ',', // separador para los decimales
      formatear: function (num) {
        num += '';
        var splitStr = num.split('.');
        var splitLeft = splitStr[0];
        var splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
        var regx = /(\d+)(\d{3})/;
        while (regx.test(splitLeft)) {
          splitLeft = splitLeft.replace(regx, '$1' + this.separador + '$2');
        }
        return this.simbol + splitLeft + splitRight;
      },
      new: function (num, simbol) {
        this.simbol = simbol || '';
        return this.formatear(num);
      }
    }


    if (priceFixed.toString() == 'NaN') {

      if (currecnyPos == 'left')
        //return currency + " " + value;
        return currency + ' ' + formatNumber.new(value, '');
      else
        //        return value + " " + currency;
        return formatNumber.new(value, '') + ' ' + currency;
    }
    else {
      if (currecnyPos == 'left')
        //return currency + " " + priceFixed;
        return currency + ' ' + formatNumber.new(value, '');
      else
        //        return priceFixed + " " + currency;
        return formatNumber.new(value, '') + ' ' + currency;
    }
  }

}
